import { Box } from '@factorialco/deprecated-design-system'
import type { Moment } from 'moment'

import type Allowance from 'modules/timeoff/store/models/Allowance'

import LegacyStatsCounter from './LegacyStatsCounter'

interface Props {
  employeeId: string
  employeeIsTerminated: boolean
  allowances: Allowance[]
  referenceDate: Moment | undefined
}

const List = ({ employeeId, employeeIsTerminated, allowances, referenceDate }: Props) => (
  <Box gap="s32" paddingTop="s32">
    {allowances.map((allowance) => {
      return (
        <LegacyStatsCounter
          employeeId={employeeId}
          employeeIsTerminated={employeeIsTerminated}
          key={allowance.id}
          allowance={allowance}
          originalReferenceDate={referenceDate}
        />
      )
    })}
  </Box>
)

export default List
